export const GA_ID = "G-5MVSTB80J7";

// 安全地呼叫 gtag
function gtag(...args: unknown[]) {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag(...(args as Parameters<typeof window.gtag>));
  }
}

// ===== 頁面瀏覽 =====
export function trackPageView(url: string) {
  gtag("config", GA_ID, { page_path: url });
}

// ===== 通用事件（帶自訂 params） =====
export function trackEvent(action: string, params: Record<string, unknown>) {
  gtag("event", action, params);
}

// ===== 搜尋 =====
export function trackSearch(keyword: string, resultCount: number) {
  trackEvent("search", { keyword, result_count: resultCount });
}

// ===== 搜尋結果點擊 =====
export function trackSearchResultClick(word: string, keyword: string, rank: number) {
  trackEvent("search_result_click", { word, keyword, rank });
}

// ===== 單字卡點擊 =====
export function trackWordClick(word: string, source: string) {
  trackEvent("word_click", { word, source });
}

// ===== 分類點擊 =====
export function trackCategoryClick(categoryName: string) {
  trackEvent("category_click", { category_name: categoryName });
}

// ===== 同義詞點擊 =====
export function trackSynonymClick(word: string, synonymWord: string) {
  trackEvent("synonym_click", { word, synonym_word: synonymWord });
}

// ===== 反義詞點擊 =====
export function trackAntonymClick(word: string, antonymWord: string) {
  trackEvent("antonym_click", { word, antonym_word: antonymWord });
}

// ===== 相關單字點擊 =====
export function trackRelatedWordClick(word: string, relatedWord: string) {
  trackEvent("related_word_click", { word, related_word: relatedWord });
}

// ===== 導覽列點擊 =====
export function trackNavClick(navItem: string) {
  trackEvent("nav_click", { nav_item: navItem });
}

// ===== 發音播放 =====
export function trackAudioPlay(word: string) {
  trackEvent("audio_play", { word });
}

// ===== 朗讀例句 =====
export function trackSpeakClick(word: string, sentenceId: number) {
  trackEvent("speak_click", { word, sentence_id: sentenceId });
}

// ===== APP 下載點擊 =====
export function trackAppDownload(platform: "ios" | "android" | "banner_image", bannerCopy: string) {
  trackEvent("app_download_click", { platform, banner_copy: bannerCopy });
}

// ===== APP Banner 關閉 =====
export function trackBannerDismiss(bannerId: string, bannerCopy: string) {
  trackEvent("banner_dismiss", { banner_id: bannerId, banner_copy: bannerCopy });
}

// ===== 滾動深度 =====
export function trackScrollDepth(depth: number, page: string) {
  trackEvent("scroll_depth", { depth_percent: depth, page });
}
